import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Layout from '../../components/common/pageLayout'
import './inspection.css'
import constant from '../../constant'
import { useEffect, useMemo, useState } from 'react'
import { v3_inspection_project_ships } from '../../actions/v3/inspection'
import Ships from '../../components/Inspection/ProjectInspectionList/ships'
import Inspection from '../../components/Inspection/ProjectInspectionList/inspection'
import InspectionDetail from '../../components/Inspection/ProjectInspectionList/InspectionDetail'
import Filter from '../../components/Inspection/ProjectInspectionList/filter'
import { getSessionStorage, setSessionStorage } from '../../utils'

const getStoredSessionValue = (key, fallback) => {
    if (!key) return fallback;
    try {
        const storedValue = getSessionStorage(key);
        return storedValue ?? fallback;
    } catch (error) {
        return fallback;
    }
};

const Index = () => {
    const location = useLocation();
    const history = useHistory();
    const { projectId, projectName } = location.state || {};
    const filterStorageKey = projectId ? `iship:inspection:project:${projectId}:filters` : '';
    const shipStorageKey = projectId ? `iship:inspection:project:${projectId}:ship` : '';
    const [selectedInspection, setInspection] = useState(null);

    const isPop = history.action === 'POP';

    const [shipId, setShipId] = useState(() => {
        if (isPop) {
            return getStoredSessionValue(shipStorageKey, null);
        } else {
            if (shipStorageKey) setSessionStorage(shipStorageKey, null);
            return null;
        }
    });
    const [shipsData, setShipsData] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [filterPayload, setFilterPayload] = useState(() => {
        if (isPop) {
            return getStoredSessionValue(filterStorageKey, {});
        } else {
            if (filterStorageKey) setSessionStorage(filterStorageKey, {});
            return {};
        }
    });
    const [statusWiseCount, setStatusWiseCount] = useState(null)

    const statusCounters = useMemo(() => {
        const defaults = ['Unscheduled', 'Scheduled', 'In Progress', 'Accepted', 'Rejected', 'Cancelled', 'Re-Inspection'];
        const normalized = Array.isArray(statusWiseCount) ? statusWiseCount : [];
        const toKey = (value) => String(value || '').trim().toLowerCase();
        
        const counters = defaults.map((status) => {
            const match = normalized.find((item) => toKey(item?.status ?? item?.STATUS) === toKey(status));
            return {
                status,
                count: match?.count ?? match?.COUNT ?? 0,
            };
        });

        const totalCount = normalized.reduce((sum, item) => sum + Number(item?.count ?? item?.COUNT ?? 0), 0);
        
        return [{ status: 'Total', count: totalCount }, ...counters];
    }, [statusWiseCount]);

    useEffect(() => {
        if (!projectId) {
            history.replace(constant.Authedcomponent.inspectionIndex.url);
            return;
        }

        v3_inspection_project_ships(projectId).then((res) => {
            if (res.status) {
                setShipsData(res.result);
            }
        })
    }, [projectId, history, refresh])

    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
        if (filterStorageKey) {
            setSessionStorage(filterStorageKey, filterModel);
        }
    }

    const onChangeShip = (nextShipId) => {
        setShipId(nextShipId);
        setInspection(null);
        if (shipStorageKey) {
            setSessionStorage(shipStorageKey, nextShipId);
        }
    }
    if (!projectId) {
        return (
            <Layout title="Inspection Detail">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="alert alert-warning">Project not found. Redirecting...</div>
                    </div>
                </div>
            </Layout>
        )
    }

    const selectedShip = shipsData?.ships?.find((item) => item.SHIP_ID === shipId);
    const selectedHullLabel = selectedShip
        ? `${selectedShip.HULL_NUMBER} - ${selectedShip.SHIP_NAME}`
        : '';

    return (
        <Layout title={projectName ? `Inspection Detail | ${projectName}` : 'Inspection Detail'}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="plan-approval-index-top inspection-filters-card-top filters-card-top">
                                        <Filter
                                            onChangeFilter={onChangeFilter}
                                            statusWiseCount={statusWiseCount}
                                            initialFilter={filterPayload}
                                        />
                                        <div className="counter-box-right fat-counter-box-right">
                                            {/* <h5 className="box-title">FAT Status</h5> */}
                                            {statusCounters.map((item) => {
                                                return (
                                                    <div className="count-box">
                                                        <h6>
                                                            {item.status} <span>{item.count}</span>
                                                        </h6>
                                                    </div>
                                                )
                                            })}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <Ships
                                        data={shipsData}
                                        shipId={shipId}
                                        setShipId={onChangeShip}
                                    />
                                </div>
                                <div className="col-md-9">
                                    <Inspection
                                        selectedHullLabel={selectedHullLabel}
                                        projectName={projectName}
                                        filterPayload={filterPayload}
                                        projectId={projectId}
                                        setInspection={setInspection}
                                        shipId={shipId}
                                        setRefresh={setRefresh}
                                        refresh={refresh}
                                        setStatusWiseCount={setStatusWiseCount}

                                    />
                                    {selectedInspection && <InspectionDetail
                                        data={selectedInspection}
                                        setRefresh={setRefresh}
                                        refresh={refresh}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Index
